import React from 'react';
import './FormInput.css';

const TaskInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group full-width">
      <label className="form-label">Task / Objective</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="Describe the task or objective"
        rows="4"
      />
    </div>
  );
};

export default TaskInput;

